"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    if (!("path" in Event.prototype))
        Object.defineProperty(Event.prototype, "path", {
            get: function () {
                var path = [];
                var currentElement = this.target;
                while (currentElement) {
                    path.push(currentElement);
                    currentElement = currentElement.parentElement;
                }
                if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
                    path.push(document);
                if (path.indexOf(window) === -1)
                    path.push(window);
                return path;
            },
        });
})();
//# sourceMappingURL=event-properties.js.map